export class UpdateCredentialsProfileInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsCredentialProfile",
            "baseName": "awsCredentialProfile",
            "type": "AwsCredentialProfileInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateCredentialsProfileInput.attributeTypeMap;
    }
    constructor() {
    }
}
